/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Link, Typography } from '@zapier/design-system';

type Props = {
  /**
   * Array of links to render.
   */
  links: Array<{ text: string; href: string }>;
};

// See note in .md file.
export const CssVars = {
  flexDirection: '--UniversalFooter__HelpfulLinks-flex-direction',
  justifyContent: '--UniversalFooter__HelpfulLinks-justify-content',
};

const Styles = {
  root: css`
    display: flex;
    flex-direction: var(${CssVars.flexDirection}, column);
    justify-content: var(${CssVars.justifyContent}, center);
    text-align: center;
    flex-wrap: wrap;
    column-gap: 15px;
    row-gap: 5px;
  `,
  link: css`
    ${Typography.paragraph3Semibold};
    color: ${Colors.gray60} !important;
    // For browsers that don't yet support Flexbox gap
    padding: 0 5px;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    &:hover,
    &:focus {
      color: ${Colors.ocean} !important;
      outline: none;
    }
  `,
};

/**
 * @private
 * Links to common pages that may not render in the main navigation.
 */
export const HelpfulLinks = (props: Props) => {
  const linkNodes = props.links.map((link) => {
    return (
      <li key={link.text}>
        <Link color={null} css={Styles.link} href={link.href}>
          {link.text}
        </Link>
      </li>
    );
  });
  return <ul css={Styles.root}>{linkNodes}</ul>;
};

HelpfulLinks.defaultProps = {
  links: [
    { text: 'Pricing', href: '/pricing' },
    { text: 'Help', href: '/help' },
    { text: 'Developer Platform', href: '/platform' },
    { text: 'Press', href: '/press' },
    { text: 'Jobs', href: '/jobs/' },
    { text: 'Zapier for Companies', href: '/companies' },
  ],
};
